import { Component, OnDestroy, OnInit } from '@angular/core';
import { Classroom } from './org.classroom';
import { OrgService } from '../_services/org.service';
import { PhaseService } from '../_services/phase.service';
import { Subscription } from 'rxjs';
@Component({
	selector: 'dropdown-classroom',
	templateUrl: './dropdown-classroom.component.html',
})
export class DropdownClassroomComponent implements OnInit, OnDestroy {
	classrooms: Classroom[];
	selectedClassroom: Classroom;
	subscriptions: Subscription[] = [];

	constructor(private orgService: OrgService, public phaseService: PhaseService) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.orgService.classrooms$.subscribe((data: Classroom[]) => {
				this.classrooms = data;
				if (
					Array.isArray(this.classrooms) &&
					this.classrooms.length === 1 &&
					(!this.selectedClassroom || this.selectedClassroom.id !== this.classrooms[0].id)
				) {
					const stored = JSON.parse(localStorage.getItem('selectedClassroom') || 'null');
					if (!stored || stored.id !== this.classrooms[0].id) {
						this.orgService.setClassroom(this.classrooms[0]);
					}
				}
			})
		);

		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((data: any) => {
				this.selectedClassroom = data;
			})
		);
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
